'use client'

import React from 'react'
import { useEnv } from '@/components/providers/EnvProvider'

interface DemoLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    children: React.ReactNode
}

export function DemoLink({ children, ...props }: DemoLinkProps) {
    const { DEMO_LINK } = useEnv()
    
    return (
        <a href={DEMO_LINK} {...props}>
            {children}
        </a>
    )
}
